import { axiosInstance } from '@/api/main/instance'
import { createApiHooks } from 'syncra-api-client'

// Создаем все хуки с axios instance
export const {
  api: syncraApi,
  apiAdapter: syncraApiAdapter,
} = createApiHooks(axiosInstance);

// Экспорт типов
export type { ApiError, ApiResponse } from 'syncra-api-client';
